import { render, staticRenderFns } from "./CsatChartClient.vue?vue&type=template&id=172a4bd8&scoped=true"
import script from "./CsatChartClient.vue?vue&type=script&lang=js"
export * from "./CsatChartClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a4bd8",
  null
  
)

export default component.exports